import { NegotiationTermsSummary } from '~/features/market/negotiations/sub-components/NegotiationTermsSummary';
import { MarketFactGrid } from '~/features/shared/market-content';
import type { ServiceOpportunity } from './schemas';

type Props = { offer: NonNullable<ServiceOpportunity['latestNegotiation']>; proposed?: boolean };

export const ServiceOfferSummary = ({ offer, proposed = false }: Props) => (
  <>
    <NegotiationTermsSummary terms={offer.terms} />
    <section aria-label="Selected availability" className="space-y-3">
      <h4 className="body-text-sb">Selected availability</h4>
      {offer.selectionStatus === 'UNAVAILABLE' ? (
        <p role="status">
          The complete availability selection is unavailable. Do not accept this offer until it can
          be reviewed.
        </p>
      ) : (
        <>
          <p>
            {proposed
              ? 'Proposed selection. Availability and holds will be validated when submitting this counteroffer.'
              : 'Original selection for this offer. Current availability and holds must still be validated when accepting.'}
          </p>
          <ol className="space-y-3">
            {offer.availabilitySelection.map((selection, index) => (
              <li key={`${selection.date}:${index}`}>
                <MarketFactGrid
                  className="[overflow-wrap:anywhere]"
                  facts={[
                    { label: 'Selected date', value: selection.date },
                    {
                      label: 'Detail',
                      value:
                        selection.detailMode === 'DATE_ONLY'
                          ? 'Date only — no shift times agreed'
                          : 'Shift detail',
                    },
                    { label: 'Time zone', value: selection.timezone },
                    { label: 'Starts at', value: selection.startsAt ?? 'Not specified' },
                    { label: 'Ends at', value: selection.endsAt ?? 'Not specified' },
                    { label: 'Shift label', value: selection.shiftLabel ?? 'Not specified' },
                    { label: 'Shift type', value: selection.shiftType ?? 'Not specified' },
                    { label: 'Work location', value: selection.workLocation ?? 'Not specified' },
                    { label: 'State', value: selection.stateCode ?? 'Not specified' },
                    {
                      label: 'Rate override type',
                      value: selection.rateOverrideType ?? 'No override',
                    },
                    {
                      label: 'Hourly rate override',
                      value: selection.pricePerHourOverride ?? 'No override',
                    },
                    {
                      label: 'Shift rate override',
                      value: selection.pricePerShiftOverride ?? 'No override',
                    },
                    {
                      label: 'Call shift rate override',
                      value: selection.pricePerCallShiftOverride ?? 'No override',
                    },
                  ]}
                />
              </li>
            ))}
          </ol>
        </>
      )}
    </section>
  </>
);
